import HttpClientToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { ActividadProps, BuscarActividadParams, BuscarReasignacionesCancelacionesParams, BuscarReasignacionesCancelacionesResponse, CancelarActividadesParams, ReasignarActividadesParams, ReasignarActividadParams } from '../../interfaces/admin/ActividadInterface';

export const BuscarActividad = ( params: BuscarActividadParams ) => {

    return new Promise<ActividadProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Actividad/BuscarActividad', params, token)
            .then( ({ data } : { data : ActividadProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const BuscarReasignacionesCancelaciones = ( params: BuscarReasignacionesCancelacionesParams ) => {

    return new Promise<BuscarReasignacionesCancelacionesResponse[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Actividad/BuscarReasignacionesCancelaciones', params, token)
            .then( ({ data } : { data : BuscarReasignacionesCancelacionesResponse[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ReasignarActividad = ( params: ReasignarActividadParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Actividad/ReasignarActividad', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const CancelarActividades = ( params: CancelarActividadesParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Actividad/CancelarActividades', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const ReasignarActividades = ( params: ReasignarActividadesParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Actividad/ReasignarActividades', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}
